import { useContext, useEffect } from "react";
import { UserContext } from "../../../context/user";
import { Outlet } from "react-router-dom";
import { SplashScreen } from "../../../components/loading-screen";
import { MeService } from "../../../services/auth";
import { enqueueSnackbar } from "notistack";
import { useRouter } from "../../hooks";

const AuthMiddleware = ({ children } : { children: JSX.Element }) => {

    const router = useRouter();

    const { user, setUser } = useContext(UserContext);

    const checkUser = async () => {

        await MeService().then(resp => {
            setUser(resp.data);
        }).catch(error => {
            enqueueSnackbar('Faça login para acessar', {
                variant: 'error'
            });
            router.push('/');
        });

    }

    useEffect(() => {
        if(user == null)
        {
            checkUser();
        }
    }, []);

    if(user == null)
    {
        return <SplashScreen />
    }else
    {
        return children;
    }

}

export default AuthMiddleware;